import { useFieldArray, useWatch } from "react-hook-form";

const CouponForm = ({ t, control, register, errors, watch }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "coupons",
  });

  const couponEnabled = watch("couponEnabled");

  const couponsWatch = useWatch({
    control,
    name: "coupons",
  });

  // Add new coupon
  const handleAdd = () => {
    append({
      title: "",
      titleEn: "",
      body: "",
      bodyEn: "",
      code: "",
      discountValue: "",
      discountType: "",
      startDate: "",
      expirationDate: "",
      maxUseCount: "",
    });
  };

  return (
    <div className="my-card mt-3">
      <div className="my-card-header text-primary">{t("coupon")}</div>

      <div className="my-card-body">
        {/* Enable Coupon */}
        <div className="col-12">
          <div className="form-group d-flex gap-1 align-items-center">
            <input type="checkbox" {...register("couponEnabled")} />

            <label>{t("enableCoupon")}</label>
          </div>
        </div>

        {couponEnabled && (
          <>
            {fields?.map((item, index) => {
              return (
                <div className="my-card mt-3" key={item.id}>
                  <div className="row">
                    {/* Arabic Title */}
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="form-label">{t("title")}</label>
                        <input
                          type="text"
                          {...register(`coupons.${index}.title`)}
                          className="form-control"
                          placeholder={t("title")}
                        />
                        <p className="text-danger">
                          {errors?.coupons?.[index]?.title?.message}
                        </p>
                      </div>
                    </div>

                    {/* English Title */}
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="form-label">{t("titleEn")}</label>
                        <input
                          type="text"
                          {...register(`coupons.${index}.titleEn`)}
                          className="form-control"
                          placeholder={t("titleEn")}
                        />
                        <p className="text-danger">
                          {errors?.coupons?.[index]?.titleEn?.message}
                        </p>
                      </div>
                    </div>

                    {/* Arabic Body */}
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {t("description")}
                        </label>
                        <textarea
                          {...register(`coupons.${index}.body`)}
                          className="form-control"
                          placeholder={t("description")}
                          rows="4"
                        />
                        <p className="text-danger">
                          {errors?.coupons?.[index]?.body?.message}
                        </p>
                      </div>
                    </div>

                    {/* English Body */}
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {t("descriptionEn")}
                        </label>
                        <textarea
                          {...register(`coupons.${index}.bodyEn`)}
                          className="form-control"
                          placeholder={t("descriptionEn")}
                          rows="4"
                        />
                        <p className="text-danger">
                          {errors?.coupons?.[index]?.bodyEn?.message}
                        </p>
                      </div>
                    </div>

                    {/* Coupon Code */}
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {t("couponCode")}
                        </label>
                        <input
                          type="text"
                          {...register(`coupons.${index}.code`)}
                          className="form-control"
                          placeholder={t("couponCode")}
                        />
                        <p className="text-danger">
                          {errors?.coupons?.[index]?.code?.message}
                        </p>
                      </div>
                    </div>

                    {/* Discount Type */}
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {t("discountType")}
                        </label>

                        <select
                          {...register(`coupons.${index}.discountType`)}
                          className="form-control"
                        >
                          <option value="">
                            --{t("discountType")}--
                          </option>

                          <option value="0">
                            {t("percentage")}
                          </option>

                          <option value="1">
                            {t("fixed")}
                          </option>
                        </select>

                        <p className="text-danger">
                          {errors?.coupons?.[index]?.discountType?.message}
                        </p>
                      </div>
                    </div>

                    {/* Discount Value */}
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {t("discountValue")}
                        </label>

                        <input
                          type="number"
                          {...register(`coupons.${index}.discountValue`)}
                          className="form-control"
                          placeholder={t("discountValue")}
                        />

                        <p className="text-danger">
                          {errors?.coupons?.[index]?.discountValue?.message}
                        </p>
                      </div>
                    </div>

                    {/* Max Use Count */}
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {t("maxUseCount")}
                        </label>

                        <input
                          type="number"
                          {...register(`coupons.${index}.maxUseCount`)}
                          className="form-control"
                          placeholder={t("maxUseCount")}
                        />

                        <p className="text-danger">
                          {errors?.coupons?.[index]?.maxUseCount?.message}
                        </p>
                      </div>
                    </div>

                    {/* Start Date */}
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {t("startDate")}
                        </label>

                        <input
                          type="date"
                          {...register(`coupons.${index}.startDate`)}
                          className="form-control"
                        />

                        <p className="text-danger">
                          {errors?.coupons?.[index]?.startDate?.message}
                        </p>
                      </div>
                    </div>

                    {/* Expiration Date */}
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {t("expirationDate")}
                        </label>

                        <input
                          type="date"
                          {...register(`coupons.${index}.expirationDate`)}
                          className="form-control"
                        />

                        <p className="text-danger">
                          {errors?.coupons?.[index]?.expirationDate?.message}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            {/* Remove */}
            {fields.length > 1 && (
              <div
                className="remove-btn mt-3"
                onClick={() => remove(fields.length - 1)}
              >
                <i className="fas fa-minus plus-icon"></i>{" "}
                {t("remove")}
              </div>
            )}

            {/* Add */}
            <div className="add-btn mt-3" onClick={handleAdd}>
              <i className="fas fa-plus plus-icon"></i>{" "}
              {t("add")}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CouponForm;